import React, { useState } from "react";
import { Button, Divider } from "antd";
import { Layout, Menu } from "antd";
import type { MenuProps } from "antd";
import "./Restaurant.scss";
import { LeftOutlined, RightOutlined, StarOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import DishModal from "./DishModal";

const { Sider, Content } = Layout;


const RestaurantHome: React.FC = () => {
    const [active, setActive] = useState("Delivery");
    const [isModalOpen, setIsModalOpen] = useState(false)

    const items: { key: string; label: string,menus:{image:string,name:string,desc:string,price:number}[] }[] = [
        { key: "pastOrders", label: "Past Orders", menus:[{image:"/Home/fastestBg.svg'",name:"menu1",desc:"desc",price:3},
            {image:"",name:"menu1",desc:"desc",price:3}
        ] },
        { key: "profile", label: "Profile", menus:[{image:"/Home/fastestBg.svg'",name:"menu1",desc:"desc",price:3},
            {image:"",name:"menu1",desc:"desc",price:3}
        ]  },
        { key: "notification", label: "Notification" ,menus:[{image:"/Home/fastestBg.svg'",name:"menu1",desc:"desc",price:3},
            {image:"",name:"menu1",desc:"desc",price:3}
        ]},
        { key: "addresses", label: "Addresses" ,menus:[{image:"/Home/fastestBg.svg'",name:"menu1",desc:"desc",price:3},
            {image:"",name:"menu1",desc:"desc",price:3}
        ]},
        { key: "settings", label: "Settings", menus:[{image:"/Home/fastestBg.svg'",name:"menu1",desc:"desc",price:3},
            {image:"",name:"menu1",desc:"desc",price:3}
        ] },
      ];

        const [selectedKey, setSelectedKey] = useState<string>("pastOrders");
      
 const onClick: MenuProps["onClick"] = (e) => {
    setSelectedKey(e.key as string);
  };

  return (
    <div style={{ padding: "20px", background:"white" }}>
    
      <div
        style={{
          height: "198px",
          width: "100%",
          borderRadius: "10px",
          backgroundImage: "url('/Home/fastestBg.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Profile Image Overlapping */}
        <div
          style={{
            position: "absolute",
            left: "10%",
            bottom: "-66px", // Half of 132px
            transform: "translateX(-50%)",
            borderRadius: "50%",
            width: "132px",
            height: "132px",
            border: "5px solid #fff",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <img
            src={'/Home/newBg.svg'}
            alt="Profile"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      <div className="booktable-container">
      {/* Book a Table Button */}
      <Button className="book-btn">Book a Table</Button>

      {/* Switch Toggle */}
      <div className="switch-toggle">
        <button
          className={`switch-btn ${
            active === "Delivery" ? "active" : ""
          }`}
          onClick={() => setActive("Delivery")}
        >
          Delivery
        </button>
        <button
          className={`switch-btn ${
            active === "Pickup" ? "active" : ""
          }`}
          onClick={() => setActive("Pickup")}
        >
          Pickup
        </button>
      </div>
    </div>

<div className="flex-space-between">
    <div className="restaurant-info">
      <div className="restaurant-name">Restaurant Name</div>
      <div className="restaurant-address">
        123 Main Street, Vancouver BC
      </div>
      <div className="restaurant-timing">
        <span className="open-now">Open now</span>. 11 AM – 12 Midnight
      </div>
    </div>

    <div className="delivery-info-container">
      {/* Left box */}
      <div className="delivery-box">
        <div className="delivery-section">
          <div className="main-text">$3.99</div>
          <div className="sub-text">Delivery Fee</div>
        </div>

        <div className="vertical-divider"></div>

        <div className="delivery-section">
          <div className="main-text">40 min</div>
          <div className="sub-text">Delivery Time</div>
        </div>
      </div>

      {/* Right box */}
      <div className="rating-box">
        <div className="rating-top"> 
        <div
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "green",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <img
              src="/star-white.svg"
              alt="star"
              style={{ width: 14, height: 14 }}
            /> */}
            <StarOutlined style={{ color:"white" }} />
          </div>4.6</div>
        <div className="horizontal-divider"></div>
        <div className="rating-bottom">2k+ Ratings</div>
      </div>
    </div>

    </div>

     <Divider/>

     <Layout style={{ minHeight: "100vh", padding:"0px" }}>
      <Sider
        width={320}
        style={{
          background: "#fff",
          borderRight: "1px solid #f0f0f0",
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={onClick}
          style={{ borderRight: 0 }}
          className="user-siderail"
          items={items.map((item) => ({
            key: item.key,
            label: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: 63,
                  padding: "0 16px",
                  position: "relative",
                  background:
                    selectedKey === item.key
                      ? "linear-gradient(270deg, rgba(195, 35, 64, 0.15) 0%, rgba(195, 35, 64, 0) 98.77%)"
                      : "transparent",
                  color: selectedKey === item.key ? "#C32340" : "rgba(0,0,0,0.6)",
                  fontWeight: 400,
                  fontSize: 20,
                }}
              >
                {/* <span style={{ marginRight: 10 }}>{item.icon}</span> */}
                {item.label}

                {selectedKey === item.key && (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      width: 7,
                      height: "100%",
                      background: "#C32340",
                    }}
                  />
                )}
              </div>
            ),
          }))}
        />
      </Sider>

      <Layout>
        <Content
          style={{
            background: "#fff",
            padding: 24,
            minHeight: 280,
          }}
        >
             <div className="items-list">
      {items.map((section) => (
        <div key={section.key} className="section">
          {/* Label */}
          <div className="section-label">{section.label}</div>

          {/* Menus */}
          {section.menus.map((menu, idx) => (
            <Row
              key={idx}
              className="menu-row"
              align="middle"
              justify="space-between"
            >
              <Col className="menu-left">
                <img
                  src='/Home/fastestBg.svg'
                  alt={menu.name}
                  className="menu-image"
                />
                <div className="menu-details">
                  <div className="menu-name">{menu.name}</div>
                  <div className="menu-price">${menu.price}</div>
                  <div className="menu-desc">{menu.desc}</div>
                </div>
              </Col>
              <Col className="menu-right">
                <Button className="add-btn" onClick={()=>setIsModalOpen(true)}>Add +</Button>
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </div>
          
        </Content>
      </Layout>

      <DishModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Layout>

    </div>
  );
};

export default RestaurantHome;
